import React from "react"
import CustomSelect from "../../../../../ui/atoms/CustomSelect"
import { isSelected, orderBy, OrderByItem } from "../../../data/sorting"

interface Props {
  current?: OrderByItem
  onChange: (value: OrderByItem) => void
}

const OrderByDropdown = ({ current, onChange }: Props) => {
  const getValue = () =>
    current ? orderBy.find((x) => isSelected(x.value, current))?.id : undefined

  return (
    <CustomSelect
      values={orderBy.map((x) => ({
        id: x.id,
        label: x.label,
      }))}
      value={getValue()}
      onChange={(id) => {
        const newValue = orderBy.find((x) => x.id === id)
        if (newValue) {
          onChange(newValue.value)
        }
      }}
      size="small"
    />
  )
}

export default OrderByDropdown
